export function GetPdfSrcWithBust(file: string): string {
  if (!file || file.startsWith("data:")) return file;
  const hasQuery = file.includes("?");
  return `${file}${hasQuery ? "&" : "?"}v=${encodeURIComponent(String(Date.now()))}`;
}

export function OpenPdfInNewTab(file: string): void {
  const src = GetPdfSrcWithBust(file);
  window.open(src, "_blank", "noopener,noreferrer");
}
